import { useContractStore } from '@/stores/contract';
import type { PreloadHandler } from '@/types/router';
import type { RouteLocationNormalized } from 'unplugin-vue-router';

export const preloadLogos: PreloadHandler = async (
  to: RouteLocationNormalized,
) => {
  const { getLogos } = useContractStore();

  if (!(to.params as { contractId: string }).contractId) {
    console.error('Error in data preloader: missing required route param');

    return;
  }

  await getLogos((to.params as { contractId: string }).contractId);
};
